import React from 'react';
import { Form, AutoComplete } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Layout from './layout';

const defaultRules = [
  {
    required: true,
    message: '学生不能为空',
  },
];

const constructName = (item) => {
  let enname = item.enname;
  let cnname = item.cnname;
  let student_school_id = item.student_school_id;
  if (typeof enname === 'undefined') enname = 'No English Name';
  if (typeof cnname === 'undefined') cnname = 'No Chinese Name';
  if (typeof student_school_id === 'undefined')
    student_school_id = 'No School Id';

  return enname.concat(' ', cnname, ' ', student_school_id);
};

const constructOptionLabel = (item) => {
  const phone = item.phone ? ` / ${item.phone}` : '';
  return (
    <div>
      <div>{constructName(item)}</div>
      {phone && <div style={{ fontSize: 12, color: '#999' }}>{phone}</div>}
    </div>
  );
};

const StudentFormItem = (props) => {
  const { fetchStudentList, studentList, form, autoCompleteStyle } = props;
  const layouts = props.formItemLayout
    ? props.formItemLayout
    : Layout.formItemLayout;
  const rules = props.rules ? props.rules : defaultRules;
  let itemLabel = props.itemLabel ? props.itemLabel : '学生';
  itemLabel = itemLabel === 'NONE' ? null : itemLabel;

  const option = studentList.map((item) => {
    return { value: constructName(item), label: constructOptionLabel(item), key: item._id };
  });

  return (
    <Form.Item
      label={itemLabel}
      {...layouts}
      name='student'
      rules={rules}
      form={form}
    >
      <AutoComplete
        style={autoCompleteStyle}
        options={option}
        dropdownMatchSelectWidth={props.dropdownMatchSelectWidth || 420}
        listHeight={props.listHeight || 360}
        filterOption={false}
        onChange={(e) => {
          form.setFieldsValue({ student: e, student_id: undefined });
          fetchStudentList(e);
        }}
        placeholder={
          <>
            <SearchOutlined />
            &nbsp; search students on the system
          </>
        }
        onSelect={(v, o) => {
          form.setFieldsValue({ student: v, student_id: o.key });
          if (props.onStudentSelect) {
            props.onStudentSelect(o.key);
          }
        }}
      />
    </Form.Item>
  );
};

export default StudentFormItem;
